import { UAPPlacementTypeAlias as EPT } from '@bingads-webui-campaign-react/unified-ad-preview-library-cmui';

//
// Ad Preview Constants
export const extraPlacementInfo = {
  [EPT.MSANV2.MSEdgeCarousel]: {
    previewTitle: _TL_('Microsoft Edge carousel'),
    previewHeaderTitle: _TL_('Ad preview (2.01 : 1 aspect ratio)'),
    customClassName: 'mmav2_201x100',
    imagePreviewHeight: 10, // 152,
    editingPlacementType: EPT.MSANV2.MSEdgeCarousel,
    hasLogo: true,
  },
  [EPT.MSANV2.MSANBanner]: {
    previewTitle: _TL_('MSN banner'),
    previewHeaderTitle: _TL_('Ad preview (2 : 1 aspect ratio)'),
    customClassName: 'mmav2_200x100',
    imagePreviewHeight: 100,
    editingPlacementType: EPT.MSANV2.MSANBanner,
  },
  [EPT.MSANV2.MSANRiver]: {
    previewTitle: _TL_('MSN feed'),
    previewHeaderTitle: _TL_('Ad preview (1.91 : 1 aspect ratio)'),
    customClassName: 'mmav2_191x100',
    imagePreviewHeight: 200,
    editingPlacementType: EPT.MSANV2.MSANRiver,
    hasLogo: true,
  },
  [EPT.MSANV2.MSNCarousel]: {
    previewTitle: _TL_('MSN carousel'),
    previewHeaderTitle: _TL_('Ad preview (1.69 : 1 aspect ratio)'),
    customClassName: 'mmav2_169x100',
    imagePreviewHeight: 372,
    editingPlacementType: EPT.MSANV2.MSNCarousel,
  },
  [EPT.MSANV2.MSNPartnerStripe]: {
    previewTitle: _TL_('MSN partner stripe'),
    previewHeaderTitle: _TL_('Ad preview (1.53 : 1 aspect ratio)'),
    customClassName: 'mmav2_153x100',
    imagePreviewHeight: 150,
    editingPlacementType: EPT.MSANV2.MSNPartnerStripe,
  },
  [EPT.MSANV2.MSNRestoday]: {
    previewTitle: _TL_('MSN Restoday'),
    previewHeaderTitle: _TL_('Ad preview (1.24 : 1 aspect ratio)'),
    customClassName: 'mmav2_124x100',
    imagePreviewHeight: 84,
    editingPlacementType: EPT.MSANV2.MSNRestoday,
  },
  [EPT.MSANV2.MSANRectangle]: {
    previewTitle: _TL_('MSN rectangle image'),
    previewHeaderTitle: _TL_('Ad preview (1.20 : 1 aspect ratio)'),
    customClassName: 'mmav2_120x100',
    imagePreviewHeight: 250,
    editingPlacementType: EPT.MSANV2.MSANRectangle,
    hasLogo: true,
  },
  [EPT.MSANV2.MSEdgeMobile]: {
    previewTitle: _TL_('Microsoft Edge mobile'),
    previewHeaderTitle: _TL_('Ad preview (1 : 1 aspect ratio)'),
    customClassName: 'mmav2_1x1',
    imagePreviewHeight: 150,
    editingPlacementType: EPT.MSANV2.MSEdgeMobile,
    hasLogo: true,
  },
  [EPT.Outlook.Mobile]: {
    previewTitle: _TL_('Microsoft Outlook web (mobile)'),
    customClassName: 'outlook_text_mobile',
    editingPlacementType: EPT.Outlook.Mobile,
    hasLogo: true,
  },
  [EPT.Outlook.Web]: {
    previewTitle: _TL_('Microsoft Outlook web (computer)'),
    customClassName: 'outlook_text_web',
    editingPlacementType: EPT.Outlook.Web,
    hasLogo: true,
  },
  [EPT.Responsive.MSAN.WideImage]: {
    previewTitle: _TL_('MSN feed'),
    previewHeaderTitle: _TL_('Ad preview (1.91 : 1 aspect ratio)'),
    customClassName: 'msan_191x100',
    imagePreviewHeight: 200,
    disclaimerMessage: _TL_('This is an example of how your ad could appear on other websites on the Microsoft Advertising Network. The final ad format is likely to change to match the look and feel of the website.'),
    editingPlacementType: EPT.MSAN.WideImage,
  },
  [EPT.Responsive.MSAN.MSEdgeSingleCarousel]: {
    previewTitle: _TL_('Microsoft Edge single carousel'),
    previewHeaderTitle: _TL_('Ad preview (1.78 : 1 aspect ratio)'),
    customClassName: 'edge_178x100',
    imagePreviewHeight: 220,
    editingPlacementType: EPT.MSAN.MSEdgeSingleCarousel,
  },
  [EPT.Responsive.MSAN.MSNInArticle]: {
    previewTitle: _TL_('MSN in-article ad'),
    previewHeaderTitle: _TL_('Ad preview (1.5 : 1 aspect ratio)'),
    customClassName: 'msan_150x100',
    imagePreviewHeight: 200,
    editingPlacementType: EPT.MSAN.MSNInArticle,
  },
  [EPT.Responsive.MSAN.MSNSmallHeadline]: {
    previewTitle: _TL_('MSN small headline'),
    previewHeaderTitle: _TL_('Ad preview (1.33 : 1 aspect ratio)'),
    customClassName: 'msan_133x100',
    imagePreviewHeight: 75,
    editingPlacementType: EPT.MSAN.MSNSmallHeadline,
  },
  [EPT.Responsive.MSAN.SquareImage]: {
    previewTitle: _TL_('MSN square image'),
    previewHeaderTitle: _TL_('Ad preview (1 : 1 aspect ratio)'),
    customClassName: 'msan_1x1',
    imagePreviewHeight: 75,
    disclaimerMessage: _TL_('This is an example of how your ad could appear on other websites on the Microsoft Advertising Network. The final ad format is likely to change to match the look and feel of the website.'),
    editingPlacementType: EPT.MSAN.SquareImage,
  },
  [EPT.Responsive.MSANV2.MSANRiver]: {
    previewTitle: _TL_('MSN feed'),
    previewHeaderTitle: _TL_('Ad preview (1.91 : 1 aspect ratio)'),
    customClassName: 'mmav2_191x100',
    imagePreviewHeight: 200,
    editingPlacementType: EPT.MSANV2.MSANRiver,
    hasLogo: true,
  },
  [EPT.Responsive.MSANV2.MSEdgeMobile]: {
    previewTitle: _TL_('Microsoft Edge mobile'),
    previewHeaderTitle: _TL_('Ad preview (1 : 1 aspect ratio)'),
    customClassName: 'mmav2_1x1',
    imagePreviewHeight: 150,
    editingPlacementType: EPT.MSANV2.MSEdgeMobile,
    hasLogo: true,
  },
  [EPT.Responsive.Outlook.Mobile]: {
    previewTitle: _TL_('Microsoft Outlook web (mobile)'),
    customClassName: 'outlook_text_mobile',
    editingPlacementType: EPT.Outlook.Mobile,
  },
  [EPT.Responsive.Outlook.Web]: {
    previewTitle: _TL_('Microsoft Outlook web (computer)'),
    customClassName: 'outlook_text_web',
    editingPlacementType: EPT.Outlook.Web,
  },
  [EPT.Responsive.Boost.WindowsSpotlight]: {
    previewTitle: _TL_('Windows Spotlight'),
    previewHeaderTitle: _TL_('Ad preview'),
    editingPlacementType: EPT.Boost.WindowsSpotlight,
    hideHeaderButtons: true,
  },
  [EPT.Responsive.Boost.DiscoverCard]: {
    previewTitle: _TL_('Discover card'),
    previewHeaderTitle: _TL_('Ad preview'),
    editingPlacementType: EPT.Boost.DiscoverCard,
    hideHeaderButtons: true,
  },
  [EPT.Responsive.Boost.StartMenu]: {
    previewTitle: _TL_('Start Menu'),
    previewHeaderTitle: _TL_('Ad preview'),
    editingPlacementType: EPT.Boost.StartMenu,
    hasLogo: true,
    hideHeaderButtons: true,
  },
  [EPT.Responsive.Boost.ActionCenter]: {
    previewTitle: _TL_('Action Center'),
    previewHeaderTitle: _TL_('Ad preview'),
    editingPlacementType: EPT.Boost.ActionCenter,
    hasLogo: true,
    hideHeaderButtons: true,
  },
  [EPT.Responsive.Boost.Banner]: {
    previewTitle: _TL_('Banner'),
    previewHeaderTitle: _TL_('Ad preview'),
    editingPlacementType: EPT.Boost.Banner,
    hasLogo: true,
    hideHeaderButtons: true,
  },
  [EPT.Responsive.Boost.Prong1Prong2Feed]: {
    previewTitle: _TL_('Prong 1 / Prong 2 / Feed'),
    previewHeaderTitle: _TL_('Ad preview'),
    editingPlacementType: EPT.Boost.Prong1Prong2Feed,
    hasLogo: true,
    hideHeaderButtons: true,
  },
  [EPT.Responsive.Boost.Coachmark]: {
    previewTitle: _TL_('CoachMark'),
    previewHeaderTitle: _TL_('Ad preview'),
    editingPlacementType: EPT.Boost.Coachmark,
    hideHeaderButtons: true,
  },
};

export const responsiveMsanMMAConfig = [{
  placementSetName: 'responsiveMsanMMAConfig',
  placementTypes: [
    EPT.Responsive.MSAN.WideImage,
    EPT.Responsive.MSAN.MSEdgeSingleCarousel,
    EPT.Responsive.MSAN.MSNInArticle,
    EPT.Responsive.MSAN.MSNSmallHeadline,
    EPT.Responsive.MSAN.SquareImage,
    EPT.Responsive.Outlook.Web,
    EPT.Responsive.Outlook.Mobile,
  ],
}];

export const msanMMAV2Config = [{
  placementSetName: 'msanMMAV2Config',
  placementTypes: [
    EPT.MSANV2.MSEdgeCarousel,
    EPT.MSANV2.MSANBanner,
    EPT.MSANV2.MSANRiver,
    EPT.MSANV2.MSNCarousel,
    EPT.MSANV2.MSNPartnerStripe,
    EPT.MSANV2.MSNRestoday,
    EPT.MSANV2.MSANRectangle,
    EPT.MSANV2.MSEdgeMobile,
    EPT.Outlook.Web,
    EPT.Outlook.Mobile,
  ],
}];

export const msanMMAConfig = [{
  placementSetName: 'msanMMAConfig',
  placementTypes: [
    EPT.MSAN.WideImage,
    EPT.MSAN.MSEdgeSingleCarousel,
    EPT.MSAN.MSNInArticle,
    EPT.MSAN.MSNSmallHeadline,
    EPT.MSAN.SquareImage,
    EPT.Outlook.Web,
    EPT.Outlook.Mobile,
  ],
}];

export const responsiveMsanMMABoostConfig = [{
  placementSetName: 'responsiveMsanMMABoostConfig',
  placementTypes: [
    EPT.Responsive.MSAN.WideImage,
    EPT.Responsive.MSAN.MSEdgeSingleCarousel,
    EPT.Responsive.MSAN.MSNInArticle,
    EPT.Responsive.MSAN.MSNSmallHeadline,
    EPT.Responsive.MSAN.SquareImage,
    EPT.Responsive.Boost.WindowsSpotlight,
    EPT.Responsive.Boost.DiscoverCard,
    EPT.Responsive.Boost.StartMenu,
    EPT.Responsive.Boost.ActionCenter,
    EPT.Responsive.Boost.Prong1Prong2Feed,
  ],
}];

export const responsiveMsanMMABoostConfigV2 = [{
  placementSetName: 'responsiveMsanMMABoostConfig',
  placementTypes: [
    EPT.Responsive.MSANV2.MSANRiver,
    EPT.Responsive.MSAN.MSEdgeSingleCarousel,
    EPT.Responsive.MSAN.MSNInArticle,
    EPT.Responsive.MSAN.MSNSmallHeadline,
    EPT.Responsive.MSANV2.MSEdgeMobile,
    EPT.Responsive.Boost.WindowsSpotlight,
    EPT.Responsive.Boost.DiscoverCard,
    EPT.Responsive.Boost.StartMenu,
    EPT.Responsive.Boost.ActionCenter,
    EPT.Responsive.Boost.Prong1Prong2Feed,
  ],
}];

export const msanMMABoostConfig = [{
  placementSetName: 'msanMMABoostConfig',
  placementTypes: [
    EPT.MSAN.WideImage,
    EPT.MSAN.MSEdgeSingleCarousel,
    EPT.MSAN.MSNInArticle,
    EPT.MSAN.MSNSmallHeadline,
    EPT.MSAN.SquareImage,
    EPT.Boost.WindowsSpotlight,
    EPT.Boost.DiscoverCard,
    EPT.Boost.StartMenu,
    EPT.Boost.ActionCenter,
    EPT.Boost.Banner,
    EPT.Boost.Prong1Prong2Feed,
    EPT.Boost.Coachmark,
  ],
}];

export const msanMMABoostConfigV2 = [{
  placementSetName: 'msanMMABoostConfig',
  placementTypes: [
    EPT.MSANV2.MSANRiver,
    EPT.MSAN.MSEdgeSingleCarousel,
    EPT.MSAN.MSNInArticle,
    EPT.MSAN.MSNSmallHeadline,
    EPT.MSANV2.MSEdgeMobile,
    EPT.Boost.WindowsSpotlight,
    EPT.Boost.DiscoverCard,
    EPT.Boost.StartMenu,
    EPT.Boost.ActionCenter,
    EPT.Boost.Banner,
    EPT.Boost.Prong1Prong2Feed,
    EPT.Boost.Coachmark,
  ],
}];

export const BiddingSchemes = {
  EnhancedCpc: 'EnhancedCpc',
  MaxConversions: 'MaxConversions',
  ManualCpm: 'ManualCpm',
};

export const AdPreviewOverideStylesByKey = {
  mma_191x100: { imagePreviewHeight: 153, imagePreviewWidth: 292 },
  edge_178x100: { imagePreviewHeight: 220, imagePreviewWidth: 390 },
  msan_191x100: { imagePreviewHeight: 200, imagePreviewWidth: 382 },
  msan_150x100: { imagePreviewHeight: 200, imagePreviewWidth: 300 },
};

export const ERROR_ENTITY = {
  Campaign: 'campaign',
  AdGroup: 'adGroup',
  Ad: 'ResponsiveAd',
};
